import React, { ChangeEvent } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwButton from "../../shared/OwButton/OwButton";

type Props = {
    onClose: () => void;
    onStart: (onlyPrimary?: boolean) => void;
};

export const AccountDownloadCsvModal = (props: Props) => {
    const [onlyPrimaryAddress, setOnlyPrimaryAddress] = React.useState(false);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setOnlyPrimaryAddress(value);
    };

    const start = () => {
        props.onStart(onlyPrimaryAddress);
        props.onClose();
    };

    return (
        <div className={"AccountDownloadCsvModal p-3"}>
            <div className={"d-flex align-items-center justify-content-between"}>
                <OwTitle title={"download_csv"} tag={"h3"} />
                <div>
                    <OwButton fn={props.onClose} centerIconClass={"fas fa-times"} className={"btn-danger"} />
                </div>
            </div>
            <div className="mt-3">
                <OwCheckbox
                    fn={handleChange}
                    label={"only_primary_address"}
                    truthyVal={true}
                    falsyVal={false}
                    checked={onlyPrimaryAddress}
                />
            </div>
            <div className="mt-3">
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
